'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIOverhang = require('./UIOverhang');

var _UIOverhang2 = _interopRequireDefault(_UIOverhang);

var _shallowEqual = require('react-utils/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _Functions = require('../core/Functions');

var _BrowserTest = require('../utils/BrowserTest');

var _Timers = require('../utils/Timers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sides = ['top', 'bottom', 'left', 'right'];

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UIScrollOverhang__Wrapper'
})(['position:relative;min-height:0;']);

var UIScrollOverhang = function (_PureComponent) {
  _inherits(UIScrollOverhang, _PureComponent);

  function UIScrollOverhang() {
    var _ref;

    _classCallCheck(this, UIScrollOverhang);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = UIScrollOverhang.__proto__ || Object.getPrototypeOf(UIScrollOverhang)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      measuredScrollableArea: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }
    };

    _this.delayedMeasureScrollableArea = _this.delayedMeasureScrollableArea.bind(_this);
    _this.measureScrollableArea = _this.measureScrollableArea.bind(_this);
    _this.childRefCallback = _this.childRefCallback.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(UIScrollOverhang, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.delayedMeasureScrollableArea);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.measuredScrollableArea === this.state.measuredScrollableArea) {
        this.delayedMeasureScrollableArea();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.delayedMeasureScrollableArea);
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
    }
  }, {
    key: 'delayedMeasureScrollableArea',
    value: function delayedMeasureScrollableArea() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time
      this._timeout = (0, _Timers.requestSchedulerCallback)(this.measureScrollableArea);
    }
  }, {
    key: 'measureScrollableArea',
    value: function measureScrollableArea() {
      if (this._childEl == null) return;

      var computedStyles = window.getComputedStyle(this._childEl, null);
      if (computedStyles == null) {
        // See #4208
        return;
      }

      var _childEl = this._childEl,
          clientHeight = _childEl.clientHeight,
          clientWidth = _childEl.clientWidth,
          scrollHeight = _childEl.scrollHeight,
          scrollLeft = _childEl.scrollLeft,
          scrollTop = _childEl.scrollTop,
          scrollWidth = _childEl.scrollWidth;


      var isScrollable = function isScrollable(overflow) {
        return overflow === 'auto' || overflow === 'scroll';
      };
      var scrollsVertically = isScrollable(computedStyles.overflowY);
      var scrollsHorizontally = isScrollable(computedStyles.overflowX);

      var measuredScrollableArea = {
        top: scrollsVertically ? scrollTop : 0,
        bottom: scrollsVertically ? scrollHeight - clientHeight - scrollTop : 0,
        left: scrollsHorizontally ? scrollLeft : 0,
        right: scrollsHorizontally ? scrollWidth - clientWidth - scrollLeft : 0
      };

      if (!(0, _shallowEqual2.default)(measuredScrollableArea, this.state.measuredScrollableArea)) {
        this.setState({ measuredScrollableArea: measuredScrollableArea });
      }
    }
  }, {
    key: 'childRefCallback',
    value: function childRefCallback(ref) {
      this._childEl = (0, _reactDom.findDOMNode)(ref);
      if (this._childEl) {
        // IE needs a longer delay before measurement, or else it sometimes returns an absurdly large
        // scrollWidth.
        if ((0, _BrowserTest.isIE11)()) {
          requestAnimationFrame(this.measureScrollableArea);
        } else {
          this.delayedMeasureScrollableArea();
        }
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(evt) {
      (0, _Functions.callIfPossible)(this.props.onScroll, evt);
      this.delayedMeasureScrollableArea();
    }
  }, {
    key: 'getClonedChild',
    value: function getClonedChild(children, measuredScrollableArea) {
      var child = _react2.default.Children.only(children);
      var childTabIndex = child.props && child.props.tabIndex;
      var childIsScrollable = sides.some(function (side) {
        return measuredScrollableArea[side] > 0;
      });
      return _react2.default.cloneElement(child, {
        ref: (0, _Functions.stackRefs)('UIScrollOverhang', child.ref, this.childRefCallback),
        tabIndex: childIsScrollable ? childTabIndex || 0 : childTabIndex
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          forceOverhangs = _props.forceOverhangs,
          gradientColor = _props.gradientColor,
          Overhang = _props.Overhang,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['children', 'forceOverhangs', 'gradientColor', 'Overhang', 'size']);

      var measuredScrollableArea = this.state.measuredScrollableArea;


      var clonedChild = this.getClonedChild(children, measuredScrollableArea);

      var overhangProps = { gradientColor: gradientColor, size: size };

      // Fade smoothly from 1 (scrollable area exceeds overhang size) to 0 (no scrollable area)
      var getOpacity = function getOpacity(side) {
        return forceOverhangs[side] ? 1 : Math.min((measuredScrollableArea[side] || 0) / size, 1);
      };

      return _react2.default.createElement(
        Wrapper,
        _extends({}, rest, { onScroll: this.handleScroll }),
        clonedChild,
        _react2.default.createElement(Overhang, _extends({}, overhangProps, { opacity: getOpacity('top'), side: 'top' })),
        _react2.default.createElement(Overhang, _extends({}, overhangProps, {
          opacity: getOpacity('bottom'),
          side: 'bottom'
        })),
        _react2.default.createElement(Overhang, _extends({}, overhangProps, { opacity: getOpacity('left'), side: 'left' })),
        _react2.default.createElement(Overhang, _extends({}, overhangProps, {
          opacity: getOpacity('right'),
          side: 'right'
        }))
      );
    }
  }]);

  return UIScrollOverhang;
}(_react.PureComponent);

UIScrollOverhang.propTypes = {
  children: _react.PropTypes.element.isRequired,
  forceOverhangs: _react.PropTypes.shape({
    top: _react.PropTypes.bool,
    bottom: _react.PropTypes.bool,
    left: _react.PropTypes.bool,
    right: _react.PropTypes.bool
  }).isRequired,
  gradientColor: _UIOverhang2.default.propTypes.gradientColor,
  onScroll: _react.PropTypes.func,
  Overhang: RenderProp.getPropType(_UIOverhang2.default),
  size: _UIOverhang2.default.propTypes.size
};

UIScrollOverhang.defaultProps = {
  forceOverhangs: {
    top: false,
    bottom: false,
    left: false,
    right: false
  },
  gradientColor: _UIOverhang2.default.defaultProps.gradientColor,
  Overhang: _UIOverhang2.default,
  size: _UIOverhang2.default.defaultProps.size
};

UIScrollOverhang.displayName = 'UIScrollOverhang';

exports.default = UIScrollOverhang;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/scroll/UIScrollOverhang.js
// module id = 586
// module chunks = 171